<template>
  <div class="canvas-rotator-wrapper">
    <button class="canvas-rotator-wrapper__btn canvas-rotator-wrapper__btn--previous">
      <span class="sr-only">Previous slide</span>
    </button>
    <div class="canvas-rotator">
      <!-- NOTE: Keep suffix the same for each of these -->
      <configuration-canvas
        key="1"
        show-view="front"
        :hotspots="false"
        :labels="false"
        :always-show-full-speaker="true"
        :show-power-up="showPowerUp"
        suffix="Rotator"
      ></configuration-canvas>
      <configuration-canvas
        key="2"
        show-view="back"
        :hotspots="false"
        :labels="false"
        :show-power-up="showPowerUp"
        :always-show-full-speaker="true"
        suffix="Rotator"
      ></configuration-canvas>
    </div>
    <button class="canvas-rotator-wrapper__btn canvas-rotator-wrapper__btn--next">
      <span class="sr-only">Next slide</span>
    </button>
  </div>
</template>

<script>
import ConfigurationCanvas from "./ConfigurationCanvas.vue";
export default {
  props: {
    addToCartPage: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    $(".canvas-rotator").slick({
      dots: true,
      prevArrow: $(".canvas-rotator-wrapper__btn--previous"),
      nextArrow: $(".canvas-rotator-wrapper__btn--next")
    });
  },
  computed: {
    showPowerUp() {
      if (this.addToCartPage) {
        if (this.$store.state.selectedSKU === this.$store.state.accessorySKU) {
          return true;
        }
      }
      return false;
    }
  },
  components: {
    ConfigurationCanvas
  }
};
</script>

<style lang="scss">
@import "../scss/_variables";
.slick-dots {
  margin-top: 1em;
  margin-bottom: 1em;
  display: flex;
  justify-content: center;
  button {
    font-size: 0;
    padding: 0 5px;
    transition: transform 0.1s;
    background: transparent none;
    border: none;
    color: $greyMidDark;
    &:before {
      content: "\f111";
      font-family: FontAwesome;
      font-size: 0.75rem;
    }
    @media (min-width: 992px) {
      color: #000;
    }
  }
  .slick-active {
    button {
      transform: scale(1.2);
      &:before {
        content: "\f10c";
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@import "../scss/_variables";
.canvas-rotator-wrapper {
  position: relative;
  @media (min-width: 992px) {
    max-width: 600px;
    margin-left: auto;

    &:hover {
      .canvas-rotator-wrapper__btn {
        opacity: 1;
      }
    }
  }

  &__btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: transparent none;
    border: none;
    padding: 0 15px;
    font-size: 50px;
    transition: all 0.25s;
    z-index: 1;
    color: $greyMidDark;
    cursor: pointer;
    @media (max-width: 991px) {
      display: none !important;
    }

    &.slick-disabled {
      opacity: 0.5;
      cursor: not-allowed;

      &:focus {
        color: $greyMid;
      }
    }
    &:focus {
      color: #000;
      outline: none;
    }
    @media (min-width: 992px) {
      opacity: 0;
      display: block;
      font-size: 70px;
      &.slick-disabled {
        opacity: 0;
        &:hover {
          color: $greyMid;
        }
      }
      &:hover {
        color: #000;
        opacity: 1;
      }
    }
    &--previous {
      left: 0;
      &:before {
        content: "\f104";
        font-family: FontAwesome;
      }
    }
    &--next {
      right: 0;
      &:before {
        content: "\f105";
        font-family: FontAwesome;
      }
    }
  }
}
</style>
